import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { getRetargetingStatusText } from '../../service/RetargetingHelpers/RetargetingHelpers';
import { RetargetingStatus } from '../../typings/domain';
import { Shape2, Shape2Icon, Shape2Theme } from '../Shape2/Shape2';

import './GridRetargetingStatusCell.css';

export interface RetargetingStatusCellProps {
    status: RetargetingStatus;
    isTextVisible: boolean;
}

const BLOCK = 'grid-retargeting-status-cell';

export class GridRetargetingStatusCell extends React.PureComponent<
    RetargetingStatusCellProps
> {
    render() {
        const { status, isTextVisible } = this.props;
        const statusText = getRetargetingStatusText(status);

        return (
            <div
                className={Bem.cls({
                    block: BLOCK,
                    mods: {
                        status
                    }
                })}
            >
                {this.getStatusIcon(statusText)}
                {isTextVisible && statusText}
            </div>
        );
    }

    private getStatusIcon(title: string) {
        const { status } = this.props;

        switch (status) {
            case RetargetingStatus.active:
                return (
                    <Shape2
                        icon={Shape2Icon.statusRunning}
                        theme={Shape2Theme.light}
                        width={12}
                        height={12}
                        cls={Bem.cls(BLOCK, 'icon')}
                        title={title}
                    />
                );
            case RetargetingStatus.suspended:
            default:
                return (
                    <Shape2
                        icon={Shape2Icon.statusEnded}
                        theme={Shape2Theme.light}
                        width={12}
                        height={12}
                        cls={Bem.cls(BLOCK, 'icon')}
                        title={title}
                    />
                );
        }
    }
}
